const u = (e) => e.status === "success" ? e.requirement + " - requirement met." : e.requirement, n = (e) => {
  let t = 0;
  return e.forEach((r) => {
    r.status === "success" && t++;
  }), t;
};
export {
  n as getMetRequirementCount,
  u as getRequirementAriaLabel
};
